import { gql } from '@apollo/client';

export const UPDATE_ASSET_MUTATION = gql`
  mutation UpdateAsset(
    $id: Int!
    $name: String
    $type: String
    $gold_weight: Float
    $copper_weight: Float
    $copper_price: Float
    $certificateUrl: String
    $imageUrl: String
    $pricePerToken: Float
    $tokenizedPercentage: Float
    $stageMultiplier: Float
    $totalTokens: Float
    $minimumInvestmentAmount: Float
    $isActive: Boolean
    $requireAccreditedInvestor: Boolean
  ) {
    updateAsset(
      input: {
        id: $id
        name: $name
        type: $type
        gold_weight: $gold_weight
        copper_weight: $copper_weight
        copper_price: $copper_price
        certificateUrl: $certificateUrl
        imageUrl: $imageUrl
        pricePerToken: $pricePerToken
        tokenizedPercentage: $tokenizedPercentage
        stageMultiplier: $stageMultiplier
        totalTokens: $totalTokens
        minimumInvestmentAmount: $minimumInvestmentAmount
        isActive: $isActive
        requireAccreditedInvestor: $requireAccreditedInvestor
      }
    ) {
      statusCode
      message
      asset {
        id
        assetId
      }
    }
  }
`;
